{
    "UploadfilesFilename": "Dateiname",
    "UploadfilesFilesize": "Dateigröße",
    "UploadfilesEmailserroredsendingseebelow": "Klicken Sie für weitere Informationen",
    "UploadfilesSuccesswitherrorparagraph": "Ihre Benutzer wurden konfiguriert. Beim Senden der Willkommens-E-Mails ist jedoch ein Fehler aufgetreten.",
    "Resulttableheaderusername": "Nutzername",
    "Resulttableheaderemail": "E-Mail-Addresse",
    "Resulttableheaderrptaccess": "Meldezugriff",
    "Resulttableheaderisadmin": "Ist Admin?",
    "Resulttableheaderisocagent": "ist OC-Agent?",
    "Resulttableheaderenhancemobileapp": "Verbesserte mobile App?",
    "LanguageBulkInsertUsers_UploadfilesHeader1": "Massen-Upload von Benutzern",
    "LanguageBulkInsertUsers_UploadfilesSubheader1": "Datei importieren.",
    "LanguageBulkInsertUsers_UploadfilesButton1": "Anfang",
    "LanguageBulkInsertUsers_UploadfilesSubheader2": "Wird bearbeitet.",
    "LanguageBulkInsertUsers_UploadfilesButton2": "Der Rücken",
    "LanguageBulkInsertUsers_UploadfilesButton3": "Bestätigen",
    "LanguageBulkInsertUsers_UploadfilesSubheader3": "Importieren.",
    "LanguageBulkInsertUsers_UploadfilesSubheader4": "Hoppla.",
    "LanguageBulkInsertUsers_UploadfilesSubheader5": "Bestätigung.",
    "LanguageBulkInsertUsers_UploadfilesSubheader6": "Erfolg.",
    "LanguageBulkInsertUsers_UploadfilesButton4": "Fertig",
    "LanguageBulkInsertUsers_UploadfilesSuccessparagraph1": "Hurra! Wir haben Ihre Benutzer erfolgreich konfiguriert.",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart1": "Beginnen Sie mit dem Herunterladen und Ausfüllen der",
    "LanguageBulkInsertUsers_UploadfilesStarttextbutton": "CSV-Vorlage",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart2": "bereitgestellt.",
    "LanguageBulkInsertUsers_UploadfilesConfirmationtext": "Bestätigen Sie, dass alles korrekt eingegeben wurde, und importieren Sie dann die fertige Datei hier (alle Fehler in der Datei werden während der Konfiguration abgefangen):",
    "LanguageBulkInsertUsers_UploadfilesChoosefile": "Datei wählen",
    "LanguageBulkInsertUsers_UploadfilesDraganddrop": "oder hier per Drag & Drop.",
    "LanguageBulkInsertUsers_UploadfilesDrophere": "Legen Sie Ihre Dateien hier ab...",
    "LanguageBulkInsertUsers_UploadfilesFiledetails": "Dateidetails:",
    "LanguageBulkInsertUsers_PromptdefaultcloseMessage": "Möchten Sie das Fenster wirklich schließen und den Fortschritt verlieren?",
    "LanguageBulkInsertUsers_PromptdefaultcloseConfirm": "Ja",
    "LanguageBulkInsertUsers_PromptdefaultcloseCancel": "Absagen",
    "LanguageBulkInsertUsers_ValidationError": "Fehler: Wir konnten die Bulk-Bereitstellungsanforderung nicht verarbeiten. Siehe unten für weitere Informationen.",
    "LanguageBulkInsertUsers_SuccessTitle": "Bitte überprüfen Sie Ihre Änderungen und bestätigen Sie.",
    "LanguageBulkInsertUsers_InvalidfileformatError": "Fehler: Ungültiges Dateiformat, bitte verwenden Sie unsere CSV-Vorlage.",
    "LanguageBulkInsertUsers_MaxfilesizeError": "Fehler: Maximale Dateigröße überschritten. Maximal 10 MB erlaubt.",
    "NAME": "LanguageBulkInsertUsers"
}